const initialState = {
  filters: {
    cities: [],
    zone: [],
    price: [],
    area: [],
    stratum: [],
    room: null,
    bath: null,
    half_bath: null,
    garage: null,
    has_elevator: null,
    property_moment: null,
    discount: null,
    gatekeeper: null,
  },
  filtersItems: {},
  onboardFilters: {},
  onboardStateFilters: {
    cities: [],
    zone: [],
    price: [],
    open: process.env.GATSBY_COUNTRY === 'CO' ? true : false,
  },
  paginationData: {
    firstCharge: true,
    hasFetched: false,
    page: 1,
    orderBy: '',
  },
  formularyData: [],
};

export default initialState;
